export const sectionItemDtoTransformFields = [{
        name: "progressive",
        title: "Progressivo",
        render: (record) => record.sectionItem.progressive
        // }, {
        //   name: "transportDocumentNumber",
        //   title: "DDT ingresso",
        //   render: (record: IButcherSectionItemDTO) => record.transportDocumentNumber
    }, {
        name: "lotNumber",
        title: "Lotto",
        render: (record) => record.sectionItem.lotNumber
        /*
      }, {
        name: "srcWeight",
        title: "Kg Ingresso",
        render: (record: IButcherSectionItemDTO) => record.sectionItem.srcWeight
        }, {
          name: "srcQuantity",
          title: "Num Capi Ingresso",
          render: (record: IButcherSectionItemDTO) => record.sectionItem.srcQuantity
        }, {
          name: "srcProductTypeName",
          title: "Tipo Ingresso",
          render: (record: IButcherSectionItemDTO) => record.srcProductTypeName
          */
        // }, {
        //   name: "dstQuantity",
        //   title: "Quantità uscita",
        //   render: (record: IButcherSectionItemDTO) => record.sectionItem.dstQuantity
    }, {
        name: "dstProductTypeName",
        title: "Tipo Uscita",
        render: (record) => record.dstProductTypeName
    }, {
        name: "recipeName",
        title: "Ricetta",
        render: (record) => record.recipeName
    }, {
        name: "dstWeight",
        title: "Kg Uscita",
        render: (record) => record.sectionItem.dstWeight
    }];
